import { render } from "./ListeTableauIMDGPage.vue?vue&type=template&id=8cf46c62&ts=true"
import script from "./ListeTableauIMDGPage.vue?vue&type=script&lang=ts"
export * from "./ListeTableauIMDGPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__